import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  NavLink,
  Row,
  Button,
  
} from "reactstrap";
import Select from "react-select";
import {
  FaPaperPlane,
  FaEdit,
  FaTrashAlt,
  FaDownload,
  FaFileWord,
  FaTrash,
  FaTimes,
  FaFileExcel,
  FaFilePdf,
  FaChevronUp,
} from "react-icons/fa";
import { useLocation, useNavigate ,Link } from "react-router-dom";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import axios from "../../api/axios";
import { GlobalContext } from "../../App";
import SubHeader from "./SubHeader";
import Slidebar from "./Slidebar";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";
import profileImg from "../../assets/images/profile-img.png";
import swal from "sweetalert";
import TopHeader from "./TopHeader";
import { BsChevronRight } from "react-icons/bs";
import { InfinitySpin } from "react-loader-spinner";
import { bottom } from "@popperjs/core";
function TaskDetail() {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const currentDate = new Date().toISOString().substr(0, 10);
  const { rolexModuleData, user_id, serialSequence, userProfile, roles } =
    useContext(GlobalContext);
  const params = new URLSearchParams(location?.search);
  var param1 = params?.get("param1")
    ? parseInt(atob(params?.get("param1")))
    : null;
  // const [taskinfoisOpen, taskinfosetIsOpen] = useState('1');
  const [userDataList, setUserDataList] = useState([]);
  const [modal, setModal] = useState(false);
  // const toggle = () => setDropdownOpen((prevState) => !prevState);
  // const [dropdownOpen, setDropdownOpen] = useState(false);
  const [currentComment, setCurrentComment] = useState("");
  const [commentList, setCommentList] = useState([]);
  const [commentUpdateID, setCommentUpdateID] = useState();
  const inputFile = useRef(null);
  const inputFile2 = useRef(null);
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState();
  const [documentList, setDocumentList] = useState([]);
  const [timesheetTimeStatus, setTimesheetTimeStatus] = useState("0");
  const [timesheetTimeData, setTimesheetTimeData] = useState([]);
  const [tempTimesheetTimeDateList, setTempTimesheetTimeDateList] = useState(
    []
  );
  const [timesheetTimeDateList, setTimesheetTimeDateList] = useState([]);
  const [auditData, setAuditData] = useState([]);
  const [isBoxOpen, setIsBoxOpen] = useState(false);
  const [commentFile, setCommentFile] = useState();
  const [commentFileName, setCommentFileName] = useState();
  const [taskData, setTaskData] = useState({
    projectId: null,
    projectTitle: null,
    milestoneId: null,
    milestoneTitle: null,
    taskTitle: null,
    taskDesc: null,
    taskStatus: { value: "In Progress", label: "In Progress" },
    TaskPrirority: { value: "High", label: "High" },
    TaskCompletionDate: null,
    TaskExcpectedCompletionDate: null,
    taskStartDate: "",
    taskEndDate: "",
    taskOwner: [],
    updateId: null,
    milestoneStartDate: null,
    milestoneEndDate: null,
    projectStartDate: null,
    projectEndDate: null,
    taskCompletionPercentage: { value: "0", label: "0" },
    taskCode: null,
    projectStatus: null,
    milestoneStatus: null,
    projectOwnerId: null,
    milestoneOwnerId: null,
  });
  const [istaskStatusDiasble,setIstaskStatusDiasble] = useState("")

  const [timesheetUser, setTimsheetUser] = useState({
    timesheetDate: currentDate,
    timesheetDuration: "",
    timesheetStartTime: "",
    timesheetEndTime: "",
    BillingType: { value: "Non-Billable", label: "Non-Billable" },
    timesheetDescription: "",
    updateId: null,
  });
  const [loading, setLoading] = useState(true);
  const billingType = [
    { value: "Billable", label: "Billable" },
    { value: "Non-Billable", label: "Non-Billable" },
  ];

  // ---------------------------------------------------------- Status List --------------------------------------
  const taskStatusList = [
    { value: "In Progress", label: "In Progress", percentage: "0" },
    { value: "Near Completion", label: "Near Completion", percentage: "80" },
    { value: "Completed", label: "Completed", percentage: "100" },
    { value: "On Hold", label: "On Hold" },
    { value: "Dropped", label: "Dropped" },
  ];
  // ------------------------------------------------------------ Priority List -------------------------------------
  const taskPriorityList = [
    { value: "High", label: "High" },
    { value: "Moderate", label: "Moderate" },
    { value: "Low", label: "Low" },
  ];
  // ---------------------------------------------------------- Status List --------------------------------------
  const taskCompletionPercentageList = [
    { value: "0", label: "0", status: "In Progress" },
    { value: "10", label: "10", status: "In Progress" },
    { value: "20", label: "20", status: "In Progress" },
    { value: "30", label: "30", status: "In Progress" },
    { value: "40", label: "40", status: "In Progress" },
    { value: "50", label: "50", status: "In Progress" },
    { value: "60", label: "60", status: "In Progress" },
    { value: "70", label: "70", status: "In Progress" },
    { value: "80", label: "80", status: "Near Completion" },
    { value: "90", label: "90", status: "Near Completion" },
    { value: "100", label: "100", status: "Completed" },
  ];

  // Handle Error
  const handleError = (error) => {
    setLoading(false);
    const statusCode = error.response ? error.response.status : null;
    let errorMessage = "An error occurred!";

    if (statusCode === 500) {
      errorMessage = "Internal Server Error!";
    } else if (statusCode === 404) {
      errorMessage = "Page Not Found!";
    }

    toast.error(errorMessage, {
      position: toast.POSITION.TOP_RIGHT,
      theme: "colored",
      autoClose: 2000,
    });
  };
  // ------------------------------------------------------------- Get Task List ---------------------------------

  const getTaskList = () => {
    setLoading(true);
    axios
      .post("/getTaskList", { param1 })
      .then((response) => {
        const OwnerList =
          response?.data?.[0]?.task_data?.[0]?.task_x_owner?.map((item) => ({
            label: item?.user_data?.[0]?.name,
            value: item?.user_id,
            // email:item?.task_user?.[0]?.email_id
          })) ?? [];
        const userDataList =
          response?.data?.[0]?.task_data?.[0]?.milestone_x_owner
            ?.filter((item) => item?.isActive === "1")
            ?.map((item) => ({ label: item?.user_data?.[0]?.name, value: item?.user_id })) ??
          [];
        setUserDataList(userDataList);
        setAuditData(response?.data?.[0]?.task_data?.[0]?.audit_notification);
        setTaskData({
          projectTitle: { label:  response?.data?.[0]?.task_data?.[0]?.project_master?.[0]?.project_title, value:  response?.data?.[0]?.task_data?.[0]?.project_master?.[0]?.project_id,projectStatus: response?.data?.[0]?.task_data?.[0]?.project_master?.[0]?.project_status },
          milestoneTitle: { label:  response?.data?.[0]?.task_data?.[0]?.milestone_master?.[0]?.milestone_title, value: response?.data?.[0]?.task_data?.[0]?.milestone_master?.[0]?.milestone_id ,milestoneStatus:response?.data?.[0]?.task_data?.[0]?.milestone_master?.[0]?.milestone_status},
          projectId:
            response?.data?.[0]?.task_data?.[0]?.project_master?.[0]
              ?.project_code,
          // projectTitle:
          //   response?.data?.[0]?.task_data?.[0]?.project_master?.[0]
          //     ?.project_title,
          milestoneId:
            response?.data?.[0]?.task_data?.[0]?.milestone_master?.[0]
              ?.milestone_code,
          // milestoneTitle:
          //   response?.data?.[0]?.task_data?.[0]?.milestone_master?.[0]
          //     ?.milestone_title,
          taskTitle: response?.data?.[0]?.task_data?.[0]?.task_title,
          taskDesc: response?.data?.[0]?.task_data?.[0]?.task_desc,
          taskStatus: {
            value: response?.data?.[0]?.task_data?.[0]?.task_status,
            label:
              response?.data?.[0]?.task_data?.[0]?.task_status === "Completed"
                ? "Go Live"
                : response?.data?.[0]?.task_data?.[0]?.task_status,
          },
          TaskPrirority: {
            value: response?.data?.[0]?.task_data?.[0]?.task_priority,
            label: response?.data?.[0]?.task_data?.[0]?.task_priority,
          },
          TaskCompletionDate:
            response?.data?.[0]?.task_data?.[0]?.task_completion_date,
            TaskExcpectedCompletionDate:
            response?.data?.[0]?.task_data?.[0]?.task_expected_date,
          taskStartDate: response?.data?.[0]?.task_data?.[0]?.task_start_date,
          taskEndDate: response?.data?.[0]?.task_data?.[0]?.task_end_date,
          taskOwner: OwnerList,
          updateId: param1,
          milestoneStartDate:
            response?.data?.[0]?.task_data?.[0]?.milestone_master?.[0]
              ?.milestone_start_date,
          milestoneEndDate:
            response?.data?.[0]?.task_data?.[0]?.milestone_master?.[0]
              ?.milestone_end_date,
              projectStartDate:   response?.data?.[0]?.task_data?.[0]?.project_master?.[0]
              ?.start_date,
              projectEndDate:   response?.data?.[0]?.task_data?.[0]?.project_master?.[0]
              ?.end_date,
          taskCompletionPercentage: {
            value:
              response?.data?.[0]?.task_data?.[0]?.task_completion_percentage,
            label:
              response?.data?.[0]?.task_data?.[0]?.task_completion_percentage,
          },
          taskCode: response?.data?.[0]?.task_data?.[0]?.task_code,
          projectStatus:
            response?.data?.[0]?.task_data?.[0]?.project_master?.[0]
              ?.project_status,
          milestoneStatus:
            response?.data?.[0]?.task_data?.[0]?.milestone_master?.[0]
              ?.milestone_status,
              projectOwnerId:
              response?.data?.[0]?.task_data?.[0]?.project_master?.[0]
                ?.project_owner_id,
            milestoneOwnerId:
              response?.data?.[0]?.task_data?.[0]?.milestone_master?.[0]
                ?.milestone_owner_id,
                 });
        setIstaskStatusDiasble( response?.data?.[0]?.task_data?.[0]?.task_status)
        setLoading(false);
      })
      .catch(handleError);
  };

  // ------------------------------------------------------- Update Task --------------------------------------------
  const updateTask = (e) => {
    if (taskData?.taskTitle === null || taskData?.taskTitle === "") {
      e.preventDefault();
      toast.error("Title is required!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (taskData?.taskOwner?.length <= 0) {
      e.preventDefault();
      toast.error("Please select team members!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    }
    // else if (!taskData?.taskOwnerId?.value) {
    //     e.preventDefault();
    //     toast.error("Please select owner first!", {
    //       position: toast.POSITION.TOP_RIGHT,
    //       theme: "colored",
    //       autoClose: 2000
    //     });
    //   }
    // else if (!taskData?.taskOwner?.some(owner => owner.value === taskData?.taskOwnerId?.value)) {
    //     e.preventDefault();
    //     toast.error("Please select Owner in team members!", {
    //       position: toast.POSITION.TOP_RIGHT,
    //       theme: "colored",
    //       autoClose: 2000
    //     });
    //   }
    else if (taskData?.taskDesc === null || taskData?.taskDesc === "") {
      e.preventDefault();
      toast.error("Description is required!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (
      (taskData?.taskStartDate === null || taskData?.taskStartDate === "")
    ) {
      e.preventDefault();
      toast.error("Start date is required!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (
      (taskData?.taskEndDate === null || taskData?.taskEndDate === "") 
    ) {
      e.preventDefault();
      toast.error("End Date is required!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (
      taskData?.taskStartDate > taskData?.taskEndDate 
    ) {
      e.preventDefault();
      toast.error("Task end date should be greater than start date!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    }
     else if (
      taskData?.taskStartDate < taskData?.milestoneStartDate 
    ) {
      e.preventDefault();
      toast.error(
        `Task start date should be greater than or equal to milestone start date! ${taskData?.milestoneStartDate}`,
        {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000,
        }
      );
    } else if (
      taskData?.taskEndDate > taskData?.milestoneEndDate
    ) {
      e.preventDefault();
      toast.error(
        `Task end date should be less than or equal to milestone end date! ${taskData?.milestoneEndDate}`,
        {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000,
        }
      );
    } else if (taskData?.taskEndDate < currentDate) {
      e.preventDefault();
      toast.error(
        `You cannot update the task details as the task end date is already passed!`,
        {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000,
        }
      );
    } else {
      const params = {
        taskData: taskData,
        user_id: user_id,
        taskId: serialSequence[3]?.project_seqence,
        userProfile:userProfile
      }
      axios
        .post("/postAddTask", params)
        .then((response) => {
          if (response.status === 202) {
            e.preventDefault();
            toast.error("Task already exist!", {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
              autoClose: 2000,
            });
          } else {
            toast.success(
              `Task  ${
                taskData?.updateId != null ? "updated" : "created"
              } successfully!`,
              {
                position: toast.POSITION.TOP_RIGHT,
                theme: "colored",
                autoClose: 2000,
              }
            );
            setTaskData({
              projectId: null,
              milestoneId: null,
              taskTitle: null,
              taskDesc: null,
              taskStatus: { value: "In Progress", label: "In Progress" },
              TaskPrirority: { value: "High", label: "High" },
              TaskCompletionDate: null,
              taskStartDate: "",
              taskEndDate: "",
              taskOwner: [],
              updateId: null,
              milestoneStartDate: null,
              milestoneEndDate: null,
              projectStartDate: null,
              projectEndDate: null,
              taskCompletionPercentage: { value: "0", label: "0" },
              taskCode: null,
              projectStatus: null,
              milestoneStatus: null,
              projectOwnerId: null,
              milestoneOwnerId: null,
                        });
            getTaskList();
            window.location.href = "/task";
          }
        })
        .catch(handleError);
    }
  };
  // ----------------------------------------------------------- Handle Close ----------------------------------------------
  const handleClose = () => {
    document.getElementById("comment-text").value = "";
    setModal(false);
    setTimsheetUser({
      timesheetDate: currentDate,
      timesheetDuration: "",
      timesheetStartTime: "",
      timesheetEndTime: "",
      BillingType: { value: "Non-Billable", label: "Non-Billable" },
      timesheetDescription: "",
      updateId: null,
    });
    setTimesheetTimeStatus("0");
    // const closeBtn = (
    //     <button className="close" onClick={toggle} type="button">
    //         &times;
    //     </button>
    // )
  };

  // -------------------------------------------------------- Socket Setup ------------------------------------------

  // const socket = io.connect("http://localhost:3501");
  // socket.emit("join_room", 1);
  // const sendMessage = async () => {
  //     if (currentComment !== "") {
  //         const commentData = {
  //             room: 1,
  //             author: user_id,
  //             message: currentComment,
  //             time:
  //                 new Date(Date.now()).getHours() +
  //                 ":" +
  //                 new Date(Date.now()).getMinutes(),
  //         };

  //         await socket.emit("send_message", commentData);
  //         setCommentList((list) => [...list, commentData]);
  //         setCurrentComment("");
  //     }
  // };

  // useEffect(() => {
  //     socket.on("receive_message", (data) => {
  //         setCommentList((list) => [...list, data]);
  //     });
  // }, [socket]);
  // ---------------------------------------------------- Post Comment ---------------------------------------
  const postTaskComment = () => {
    // document.getElementById('comment-text').value = '';
    if (currentComment !== "") {
      let formData = new FormData();
      formData.append("comment_doc", commentFile);
      formData.append("user_id", user_id);
      formData.append("comment", currentComment);
      formData.append("task_id", taskData?.updateId);
      formData.append("updateId", commentUpdateID);
      formData.append("commentFile1", commentFileName);
   

      axios.post("/postTaskComment", formData).then((response) => {
        if (response) {
          getTaskComment();
          setCommentUpdateID();
          setCurrentComment("");
          FileManage();
      

        }
      });
    } else {
      toast.error("Please enter your comment!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    }
  };
  // ------------------------------------------------------------- Get Task Comment ---------------------------------

  const getTaskComment = () => {
    setLoading(true);
    axios
      .post("/getTaskComment", { param1 })
      .then((response) => {
        setCommentList(response?.data?.[0]?.task_comment_data);
        setLoading(false);
      })
      .catch(handleError);
  };

  // -------------------------------------------------------------  Update Task Comment ------------------------------
  const updateComment = (taskCommentID) => {
    const commentData = commentList?.filter(
      (data) => data?.tasks_user_comment_id === taskCommentID
    );
    setCurrentComment(commentData?.[0]?.comment);
    setCommentUpdateID(commentData?.[0]?.tasks_user_comment_id);
    setCommentFileName(commentData?.[0]?.comment_document);  
  };
  // -------------------------------------------------------------  Update Task Comment ------------------------------
  const deleteTaskComment = (taskCommentID) => {
    axios
      .post("/deleteTaskComment", { taskCommentID, user_id })
      .then((response) => {
        if (response) {
          getTaskComment();
        }
      });
  };
  // ----------------------------------------------------------------- Document Select ---------------------------------

  const onButtonClick = () => {
    inputFile.current.click();
  };
  const onButtonClick2 = () => {
    inputFile2.current.click();
  };
  const onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setFile(e.target.files?.[0]);
      setFileName(e.target.files?.[0].name);
    }
  };

  const onSelectFileComment = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setCommentFile(e.target.files?.[0]);
      setCommentFileName(e.target.files?.[0].name);
    }
  };

  // ----------------------------------------------------------------- Upload Task Document ------------------------
  const uploadTaskDocument = () => {
    if (file?.length <= 0) {
      toast.success("Please Select Document!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else {
      let formData = new FormData();
      formData.append("task_doc", file, fileName);
      formData.append("user_id", user_id);
      formData.append("task_id", taskData?.updateId);
      formData.append(
        "doc_type",
        fileName?.substring(fileName?.lastIndexOf(".") + 1)
      );
      axios.post("/uploadTaskDocument", formData).then((response) => {
        toast.success("Document is uploaded successfully!", {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000,
        });
        getTaskDocument();
        FileManage();
      });
    }
  };

  const FileManage = () => {
    setFile();
    setFileName();
    setCommentFile();
    setCommentFileName();
  };
  // ------------------------------------------------------------- Get Task Document ---------------------------------

  const getTaskDocument = () => {
    setLoading(true);
    axios
      .post("/getTaskDocument", { param1 })
      .then((response) => {
        setDocumentList(response?.data?.[0]?.tasks_documents);
        setLoading(false);
      })
      .catch(handleError);
  };

  // -------------------------------------------------------------  Update Task Comment ------------------------------
  const deleteTaskDocument = (taskDocumentID) => {
    swal({
      title: "Are you sure?",
      text: "Once removed, you will not be able to recover this document!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        swal(" Your Document has been removed!", {
          icon: "success",
        });
        axios
          .post("/deleteTaskDocument", { taskDocumentID, user_id })
          .then((response) => {
            if (response) {
              getTaskDocument();
            }
          });
      }
    });
  };
  // ---------------------------------------------------- Post TaskTimeSheet ---------------------------------------
  const postTaskTimeSheet = (e) => {
    e.preventDefault();
    if (
      timesheetUser?.timesheetDate === null ||
      timesheetUser?.timesheetDate === ""
    ) {
      toast.error("Date is required!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (timesheetUser?.timesheetDate > currentDate) {
      toast.error(`Date should Less than or equal to ${currentDate} date!`, {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (
      timesheetTimeStatus === "1"
        ? timesheetUser?.timesheetStartTime === null ||
          timesheetUser?.timesheetStartTime === "" ||
          timesheetUser?.timesheetEndTime === null ||
          timesheetUser?.timesheetEndTime === ""
        : timesheetUser?.timesheetDuration === null ||
          timesheetUser?.timesheetDuration === ""
    ) {
      toast.error("Time is required!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (
      timesheetTimeStatus === "1"
        ? timesheetUser?.timesheetStartTime > timesheetUser?.timesheetEndTime
        : false
    ) {
      toast.error("End time should be greater than start time !", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (
      timesheetUser?.timesheetDescription === null ||
      timesheetUser?.timesheetDescription === ""
    ) {
      toast.error("Description is required!", {
        position: toast.POSITION.TOP_RIGHT,
        theme: "colored",
        autoClose: 2000,
      });
    } else if (
      timesheetTimeStatus === "1"
        ? (new Date(`1970-01-01T${timesheetUser?.timesheetEndTime}`).getTime() -
            new Date(
              `1970-01-01T${timesheetUser?.timesheetStartTime}`
            ).getTime()) /
            1000 /
            60 /
            60 >
          parseFloat(serialSequence[4]?.hours) +
            parseFloat(serialSequence[4]?.minutes) / 100
        : timesheetUser?.timesheetDuration >
          parseFloat(serialSequence[4]?.hours) +
            parseFloat(serialSequence[4]?.minutes) / 100
    ) {
      toast.error(
        `Your daily working hours limit cannot be more than ${
          serialSequence[4]?.hours
        } hours ${
          serialSequence[4]?.minutes === "0"
            ? ""
            : serialSequence[4]?.minutes + " minutes"
        } !`,
        {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000,
        }
      );
    } else if (
      timesheetTimeStatus === "1"
        ? (new Date(`1970-01-01T${timesheetUser?.timesheetEndTime}`).getTime() -
            new Date(
              `1970-01-01T${timesheetUser?.timesheetStartTime}`
            ).getTime()) /
            1000 /
            60 /
            60 >
          tempTimesheetTimeDateList?.filter(
            (data) => data?.label === timesheetUser?.timesheetDate
          )?.[0]?.totalSum
        : timesheetUser?.timesheetDuration >
          tempTimesheetTimeDateList?.filter(
            (data) => data?.label === timesheetUser?.timesheetDate
          )?.[0]?.totalSum
    ) {
      toast.error(
        `Your working hours is exceeding more than daily hours limit. Your maximum working hours for a day cannot be more than ${
          serialSequence[4]?.hours
        } hours ${
          serialSequence[4]?.minutes === "0"
            ? ""
            : serialSequence[4]?.minutes + "minutes"
        } !`,
        {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000,
        }
      );
    } else {
      const param = {
        user_id: user_id,
        task_id: taskData?.updateId,
        timesheetUser: timesheetUser,
      };
      axios.post("/postTaskTimeSheet", param).then((response) => {
        if (response) {
          toast.success(
            `TimeSheet Log is ${
              timesheetUser?.updateId != null ? "updated" : "created"
            } successfully!`,
            {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
              autoClose: 2000,
            }
          );
          getTaskTimeSheet();
          handleClose();
        }
      });
    }
  };
  // ------------------------------------------------------------- Get Task TimeSheet ---------------------------------

  const getTaskTimeSheet = () => {
    setLoading(true);
    axios
      .post("/getTaskTimeSheet", { param1 })
      .then((response) => {
        const serialHours = parseFloat(serialSequence[4]?.hours);
        const serialMinutes = parseFloat(serialSequence[4]?.minutes);
        const TempVar = response?.data?.filter((obj, index, arr) =>
        rolexModuleData?.find( (data) => pathname === data?.description && data?.special === 1 ) || roles?.find((data) => data?.role_id === 1001)
            ? obj
            : obj.user_id === user_id
        );
        const TimesheetTimeDateList =
          TempVar?.filter(
            (obj, index, arr) =>
              arr.findIndex((o) => o.Date === obj.Date) === index
          )?.map((item) => {
            const totalSum = response?.data
              ?.filter(
                (obj) => obj.Date === item.Date && obj.user_id === item.user_id
              )
              .reduce((total, obj) => {
                const duration =
                  obj.Duration !== null && obj.Duration !== ""
                    ? parseFloat(obj.Duration)
                    : (new Date(`1970-01-01T${obj.end_time}`).getTime() -
                        new Date(`1970-01-01T${obj.start_time}`).getTime()) /
                      1000 /
                      60 /
                      60;
                return duration > 0 ? total + duration : total;
              }, 0);
            const subtractValue =
              (isNaN(serialHours) ? 0 : serialHours) +
              (isNaN(serialMinutes) ? 0 : serialMinutes) / 100;
            const adjustedTotalSum = subtractValue - totalSum;
            return {
              label: item?.Date,
              value: item?.Date,
              totalSum: adjustedTotalSum || 0, // Assign a default value of 0 if adjustedTotalSum is undefined or NaN
            };
          }) ?? [];
        setTimesheetTimeDateList(TimesheetTimeDateList);
        setTempTimesheetTimeDateList(TimesheetTimeDateList);
        setTimesheetTimeData(response?.data);
        setLoading(false);
      })
      .catch(handleError);
  };
  // ------------------------------------------------------------- Update Task TimeSheet ---------------------------------

  const uptTaskTimeSheet = (timeSheetId, date) => {
    var tempDateList = [];
    for (let i = 0; i < timesheetTimeData?.length; i++) {
      if (timesheetTimeData[i]?.tasks_timesheet_id === timeSheetId) {
        setTimsheetUser({
          timesheetDate: timesheetTimeData[i]?.Date,
          timesheetDuration: timesheetTimeData[i]?.Duration,
          timesheetStartTime: timesheetTimeData[i]?.start_time,
          timesheetEndTime: timesheetTimeData[i]?.end_time,
          BillingType: {
            value: timesheetTimeData[i]?.billing_type,
            label: timesheetTimeData[i]?.billing_type,
          },
          timesheetDescription: timesheetTimeData[i]?.description,
          updateId: timesheetTimeData[i]?.tasks_timesheet_id,
        });
        const duration =
          timesheetTimeData[i]?.Duration !== null &&
          timesheetTimeData[i]?.Duration !== ""
            ? parseFloat(timesheetTimeData[i]?.Duration)
            : (new Date(
                `1970-01-01T${timesheetTimeData[i]?.end_time}`
              ).getTime() -
                new Date(
                  `1970-01-01T${timesheetTimeData[i]?.start_time}`
                ).getTime()) /
              1000 /
              60 /
              60;
        setTimesheetTimeStatus(
          timesheetTimeData[i]?.Duration !== "" &&
            timesheetTimeData[i]?.Duration !== null
            ? "0"
            : "1"
        );
        setModal(true);
        for (let j = 0; j < timesheetTimeDateList?.length; j++) {
          if (timesheetTimeDateList[j]?.value === date) {
            tempDateList?.push({
              label: timesheetTimeDateList[j]?.label,
              value: timesheetTimeDateList[j]?.value,
              totalSum: timesheetTimeDateList[j]?.totalSum + duration,
            });
          } else {
            tempDateList?.push(timesheetTimeDateList[j]);
          }
        }
        setTempTimesheetTimeDateList(tempDateList);
      }
    }
  };
  // -------------------------------------------------------------  Update Task TimeSheet ------------------------------
  const deleteTaskTimeSheet = (taskTimeSheetID) => {
    axios
      .post("/deleteTaskTimeSheet", { taskTimeSheetID, user_id })
      .then((response) => {
        if (response) {
          toast.success("Loghours deleted successfully!", {
            position: toast.POSITION.TOP_RIGHT,
            theme: "colored",
          });
          getTaskTimeSheet();
        }
      });
  };
  // ---------------------------------------------------------- Mantain Log History ------------------------------
  const postLogHistory = () => {
    const param = {
      user_id: user_id,
      module_name: "Task Detials",
      operationPerformed: "navigate to task details screen",
    };
    axios.post("/postLogHistory", param);
  };
  // -------------------------------------------------------- Use Effect -----------------------------------------
  useEffect(() => {
    getTaskList();
    getTaskComment();
    getTaskDocument();
    getTaskTimeSheet();
    // postLogHistory();
  }, []);

  const getPreviousDate = () => {
    const daysToSubtract = Number(serialSequence[4]?.project_seqence);
    if (isNaN(daysToSubtract)) {
      // Handle invalid or non-numeric value
      return "Invalid Date";
    }

    const previousDate = new Date();
    previousDate.setDate(previousDate.getDate() - daysToSubtract);

    return previousDate.toISOString().split("T")?.[0];
  };
  const previousDate = getPreviousDate();

  const handleArrowClick = () => {
    setIsBoxOpen(!isBoxOpen);
  };
  // ----------------------------------------------------------- Html Start ----------------------------------------
  return loading ? (
    <div className="loader">
      <InfinitySpin width="200" color="#D81159" />
    </div>
  ) : (
    <>
      <TopHeader
        breadCrumb={
          <>
            <li className="nav-item">
              <a onClick={() => navigate("/home")} className="nav-link">
                Home <BsChevronRight />
              </a>
            </li>
            <li className="nav-item">
              <a
                onClick={() => navigate("/project-detail")}
                className="nav-link"
              >
                Level 0 <BsChevronRight />
              </a>
            </li>
            {taskData?.milestoneId && (
              <li className="nav-item">
                <a onClick={() => navigate("/milestones")} className="nav-link">
                  Level 1 <BsChevronRight />
                </a>
              </li>
            )}
            <li className="nav-item">
              <a onClick={() => navigate("/task")} className="nav-link">
                Tasks <BsChevronRight />
              </a>
            </li>
            <li className="nav-item">
              <span>Task Detail</span>
            </li>
          </>
        }
      />
      <SubHeader
        SubHeaderTitle="Task Detail"
        showButton={
          (rolexModuleData?.find(
            (data1) => pathname === data1?.description && data1?.update === 1
          ) && istaskStatusDiasble !== "Completed") || roles?.find((data) => data?.role_id === 1001)
            ? true
            : false
        }
        titleButton="Save"
        toggleModal={(e) => updateTask(e)}
        customeClass="tasksavebtn"
        
      />
      <div id="taskdetail" className="contentInnerWrap">
        <div className="taskdetail-wrap">
          <div className="row">
          <div className="backbuttonWrap" style={{marginBottom:10}}>
          <Link to="/task" className="btn-adduser btn btn-secondary" >
            Go  Back
           </Link>
          </div>
            <Col md={12}>
              <div className="projectstatus">
                <div className="task-heading">
                  <h5>
                    <FaChevronUp
                      onClick={handleArrowClick}
                      className={`${
                        isBoxOpen ? "arrow-down collapsed" : "arrow-down"
                      }`}
                    />{" "}
                    Task Information
                  </h5>
                </div>

                <div
                  className={`${
                    isBoxOpen ? "task-detail" : "task-detail taskdetail-open"
                  }`}
                >
                  <Form className="modelform">
                    <FormGroup>
                      <Row>
                        <Col md={taskData?.milestoneId ? 4 : 6}>
                          <FormGroup>
                            <Label htmlFor="projectid">Level 0 ID*</Label>
                            <Input
                              type="text"
                              id="projectid"
                              name="projectid"
                              value={
                                "(" +
                                serialSequence?.[0]?.prefix +
                                "-" +
                                (taskData?.projectId + ")") +
                                " - " +
                                taskData?.projectTitle?.label
                              }
                              disabled
                            />
                          </FormGroup>
                        </Col>
                        {taskData?.milestoneId && (
                          <Col md={4}>
                            <FormGroup>
                              <Label htmlFor="taskid">Level 1 ID*</Label>
                              <Input
                                type="text"
                                id="taskid"
                                name="taskid"
                                value={
                                  "(" +
                                  serialSequence[1]?.prefix +
                                  "-" +
                                  (taskData?.milestoneId + ")") +
                                  " - " +
                                  taskData?.milestoneTitle?.label
                                }
                                disabled
                              />
                            </FormGroup>
                          </Col>
                        )}

                        <Col md={taskData?.milestoneId ? 4 : 6}>
                          <FormGroup>
                            <Label htmlFor="taskid">Task ID*</Label>
                            <Input
                              type="text"
                              id="taskid"
                              name="taskid"
                              value={
                                serialSequence[3]?.prefix +
                                "-" +
                                taskData?.taskCode
                              }
                              disabled
                            />
                          </FormGroup>
                        </Col>
                        <Col md={12}>
                          <FormGroup>
                            <Label htmlFor="taskTitle">Task</Label>
                            <Input
                              type="text"
                              id="taskTitle"
                              name="taskTitle"
                              value={taskData?.taskTitle}
                              onChange={(e) =>
                                setTaskData({
                                  ...taskData,
                                  taskTitle: e.target.value,
                                })
                              }
                              disabled={
                                taskData?.projectStatus === "Inactive" ||
                                taskData?.milestoneStatus === "Inactive"
                                  ? true
                                  : roles?.find(
                                      (data) => data?.role_id === 1001
                                    ) ||
                                    taskData?.projectOwnerId === user_id ||
                                    taskData?.milestoneOwnerId === user_id 
                                  ? false
                                  : true
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col md={12}>
                          <FormGroup>
                            <Label htmlFor="owner">Assigned To*</Label>
                            <Select
                              classNamePrefix="react-select"
                              className="multi-select"
                              menuPlacement="auto"
                              maxMenuHeight={200}
                              value={taskData?.taskOwner}
                              onChange={(select) =>
                                setTaskData({ ...taskData, taskOwner: select })
                              }
                              options={userDataList}
                              isDisabled={
                                taskData?.projectStatus === "Inactive" ||
                                taskData?.milestoneStatus === "Inactive"

                                  ? true
                                  : (roles?.find(
                                      (data) => data?.role_id === 1001
                                    ) ||
                                    taskData?.projectOwnerId === user_id ||
                                    taskData?.milestoneOwnerId === user_id)
                                  ? false
                                  : true
                              }
                              isMulti
                              // {...props}
                              theme={(theme) => ({
                                ...theme,
                                colors: {
                                  ...theme.colors,
                                  primary25: "rgba(2, 137, 255,.2)",
                                  primary50: "rgba(2, 137, 255,.2)",
                                  primary75: "rgba(2, 137, 255,.2)",
                                  primary: "#0289ff",
                                },
                              })}
                            />
                          </FormGroup>
                        </Col>
                            <Col md={3}>
                              <FormGroup>
                                <Label htmlFor="startdate">Start Date</Label>
                                <Input
                                  type="date"
                                  id="milestoneStartDate"
                                  name="milestoneStartDate"
                                  min={taskData?.milestoneStartDate || taskData?.projectStartDate}
                                  max={taskData?.milestoneEndDate || taskData?.projectEndDate}
                                  value={taskData?.taskStartDate}
                                  onChange={(e) =>
                                    setTaskData({
                                      ...taskData,
                                      taskStartDate: e.target.value,
                                      taskEndDate: ""
                                    })
                                  }
                                  disabled={
                                    taskData?.projectStatus === "Inactive" ||
                                    taskData?.milestoneStatus === "Inactive"
                                      ? true
                                      : roles?.find(
                                          (data) => data?.role_id === 1001
                                        ) ||
                                        taskData?.projectOwnerId === user_id ||
                                        taskData?.milestoneOwnerId === user_id
                                      ? false
                                      : true
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col md={3}>
                              <FormGroup>
                                <Label htmlFor="duedate">End Date</Label>
                                <Input
                                  type="date"
                                  id="duedate"
                                  name="duedate"
                                  min={taskData?.milestoneStartDate }
                                  max={taskData?.milestoneEndDate }
                                  value={taskData?.taskEndDate}
                                  onChange={(e) =>
                                    setTaskData({
                                      ...taskData,
                                      taskEndDate: e.target.value,
                                    })
                                  }
                                  disabled={
                                    taskData?.projectStatus === "Inactive" ||
                                    taskData?.milestoneStatus === "Inactive" ||
                                    !taskData?.taskStartDate
                                      ? true
                                      : roles?.find(
                                          (data) => data?.role_id === 1001
                                        )||
                                        taskData?.projectOwnerId === user_id ||
                                        taskData?.milestoneOwnerId === user_id
                                      ? false
                                      : true
                                  }
                                />
                              </FormGroup>
                            </Col>

                        <Col md={3}>
                          <FormGroup>
                            <Label htmlFor="duration">Duration</Label>
                            <Input
                              type="text"
                              id="duration"
                              name="duration"
                              value={`${
                                taskData?.taskStartDate
                                  ? Math.floor(
                                      (new Date(taskData?.taskEndDate) -
                                        new Date(taskData?.taskStartDate)) /
                                        (1000 * 60 * 60 * 24)
                                    ) + 1 || "0"
                                  : " 0 "
                              } days`}
                              disabled
                            />
                          </FormGroup>
                        </Col>
                        <Col md={3}>
                          <FormGroup>
                            <Label htmlFor="status">
                              Completion Percentage (%) *
                            </Label>
                            <Select
                              classNamePrefix="react-select"
                              className="single-select"
                              menuPlacement="bottom"
                              maxMenuHeight={200}
                              value={taskData?.taskCompletionPercentage}
                              onChange={(select) =>
                                setTaskData({
                                  ...taskData,
                                  taskCompletionPercentage: select,
                                  taskStatus: {
                                    label: select?.status,
                                    value: select?.status,
                                  },
                                  TaskCompletionDate:
                                    taskData?.TaskCompletionDate === null ||
                                    taskData?.TaskCompletionDate === ""
                                      ? currentDate
                                      : taskData?.TaskCompletionDate,
                                })
                              }
                              options={taskCompletionPercentageList}
                              isDisabled={
                                taskData?.projectStatus === "Inactive" ||
                                taskData?.milestoneStatus === "Inactive" ||
                                taskData?.taskEndDate < currentDate ||
                                !rolexModuleData?.find(
                                  (data1) =>
                                    pathname === data1?.description &&
                                    data1?.update === 1
                                )
                                  ? true
                                  : false
                              }
                              theme={(theme) => ({
                                ...theme,
                                colors: {
                                  ...theme.colors,
                                  primary25: "rgba(2, 137, 255,.2)",
                                  primary50: "rgba(2, 137, 255,.2)",
                                  primary75: "rgba(2, 137, 255,.2)",
                                  primary: "#0289ff",
                                },
                              })}
                            />{" "}
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup>
                            <Label htmlFor="priority">Priority</Label>
                            <Select
                              classNamePrefix="react-select"
                              className="single-select"
                              menuPlacement="bottom"
                              maxMenuHeight={200}
                              value={taskData?.TaskPrirority}
                              onChange={(select) =>
                                setTaskData({
                                  ...taskData,
                                  TaskPrirority: select,
                                })
                              }
                              options={taskPriorityList}
                              isDisabled={
                                taskData?.projectStatus === "Inactive" ||
                                taskData?.milestoneStatus === "Inactive" ||
                                taskData?.taskEndDate < currentDate
                                  ? true
                                  : roles?.find(
                                      (data) => data?.role_id === 1001
                                    ) ||
                                    taskData?.projectOwnerId === user_id ||
                                    taskData?.milestoneOwnerId === user_id
                                  ? false
                                  : true
                              }
                              theme={(theme) => ({
                                ...theme,
                                colors: {
                                  ...theme.colors,
                                  primary25: "rgba(2, 137, 255,.2)",
                                  primary50: "rgba(2, 137, 255,.2)",
                                  primary75: "rgba(2, 137, 255,.2)",
                                  primary: "#0289ff",
                                },
                              })}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup>
                            <Label htmlFor="status">Status</Label>
                            <Select
                              classNamePrefix="react-select"
                              className="single-select"
                              menuPlacement="bottom"
                              maxMenuHeight={200}
                              value={taskData?.taskStatus}
                              onChange={(select) =>
                                setTaskData({
                                  ...taskData,
                                  taskStatus: select,
                                  TaskCompletionDate:
                                    taskData?.TaskCompletionDate === null ||
                                    taskData?.TaskCompletionDate === ""
                                      ? currentDate
                                      : taskData?.TaskCompletionDate,
                                  taskCompletionPercentage:
                                    select?.value !== "Dropped" &&
                                    select?.value !== "On Hold"
                                      ? {
                                          label: select?.percentage,
                                          value: select?.percentage,
                                        }
                                      : taskData?.taskCompletionPercentage,
                                  taskUATSignOffForm: "",
                                })
                              }
                              options={taskStatusList}
                              isDisabled={
                                taskData?.projectStatus === "Inactive" ||
                                taskData?.milestoneStatus === "Inactive" ||
                                taskData?.taskEndDate < currentDate ||
                                !rolexModuleData?.find(
                                  (data1) =>
                                    pathname === data1?.description &&
                                    data1?.update === 1
                                )
                                  ? true
                                  : false
                              }
                              theme={(theme) => ({
                                ...theme,
                                colors: {
                                  ...theme.colors,
                                  primary25: "rgba(2, 137, 255,.2)",
                                  primary50: "rgba(2, 137, 255,.2)",
                                  primary75: "rgba(2, 137, 255,.2)",
                                  primary: "#0289ff",
                                },
                              })}
                            />{" "}
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup>
                            <Label htmlFor="completionDate">
                              Expected Completion Date
                            </Label>
                            <Input
                              type="date"
                              id="completiondate"
                              name="completiondate"
                              min={taskData?.taskStartDate}
                              disabled={
                                taskData?.projectStatus === "Inactive" ||
                                taskData?.milestoneStatus === "Inactive" ||
                                taskData?.taskStatus?.value === "Completed" ||
                                taskData?.taskEndDate < currentDate
                              }
                              value={taskData?.TaskExcpectedCompletionDate}
                              onChange={(e) =>
                                setTaskData({
                                  ...taskData,
                                  TaskExcpectedCompletionDate: e.target.value,
                                })
                              }
                            />
                          </FormGroup>
                        </Col>
                        {taskData?.taskStatus?.value === "Completed" ? (
                            <Col md={6}>
                              <FormGroup>
                                <Label htmlFor="completionDate">
                                  Completion Date
                                </Label>
                                <Input
                                  type="text"
                                  id="completiondate"
                                  name="completiondate"
                                  value={
                                    taskData?.TaskCompletionDate === null ||
                                    taskData?.TaskCompletionDate === ""
                                      ? new Date(
                                          currentDate
                                        )?.toLocaleDateString("en-TT")
                                      : new Date(
                                          taskData?.TaskCompletionDate
                                        )?.toLocaleDateString("en-TT")
                                  }
                                  disabled
                                />
                              </FormGroup>
                            </Col>
                        ) : null}
                        <Col md={12}>
                          <FormGroup>
                            <Label htmlFor="taskdetail"> Description </Label>
                            {/* This is for employeee edit */}
                            {/* || rolexModuleData?.find((data1) => pathname === data1?.description && data1?.update === 1) */}
                            <Input
                              type="textarea"
                              id="taskdetail"
                              style={{ minHeight: "180px" }}
                              value={taskData?.taskDesc}
                              onChange={(e) =>
                                setTaskData({
                                  ...taskData,
                                  taskDesc: e.target.value,
                                })
                              }
                              disabled={
                                taskData?.projectStatus === "Inactive" ||
                                taskData?.milestoneStatus === "Inactive"
                                  ? true
                                  : (roles?.find( (data) => data?.role_id === 1001 || rolexModuleData?.find( (data1) => pathname === data1?.description && data1?.update === 1 ) ) ||
                                  taskData?.projectOwnerId === user_id ||
                                  taskData?.milestoneOwnerId === user_id)
                                  ? false
                                  : true
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </FormGroup>
                  </Form>
                </div>
              </div>
            </Col>

            <Col md={12}>
              <div className="projectstatus">
                <div className="comment">
                  <Tabs defaultActiveKey="first" className="timesheet">
                    <Tab eventKey="first" title="Comments">
                      <div className="commentsection">
                        <div className="postcomment">
                          {commentList?.length > 0 ? (
                            // <Scrollbars
                            //     autoHeight={true}
                            //     autoHeightMax={350}
                            // >
                            <>
                              {commentList
                                ?.sort((a, b) =>
                                  a.updatedDate < b.updatedDate ? 1 : -1
                                )
                                ?.map((data) => (
                                  <div className="commentInner">
                                    <div className="comment-boxwrap">
                                      <div className="commentbox-header">
                                        <div className="commentboximg">
                                          <img
                                            src={
                                              data?.user_master?.[0]
                                                ?.profile_image_url?.length > 0
                                                ? global.SERVER_URL +
                                                  "/userImg/" +
                                                  data?.user_master?.[0]
                                                    ?.profile_image_url
                                                : profileImg
                                            }
                                            alt="User Profile Images"
                                          />
                                          <strong>
                                            {data?.user_master?.[0]?.name}
                                          </strong>
                                        </div>
                                        <div className="actButton">
                                          {rolexModuleData?.find(
                                            (data1) =>
                                              pathname === data1?.description &&
                                              data1?.update === 1
                                          ) && data?.user_id === user_id ? (
                                            <NavLink 
                                              onClick={() =>
                                                updateComment(
                                                  data?.tasks_user_comment_id
                                                )
                                              }
                                            >
                                              <FaEdit />
                                            </NavLink>
                                          ) : null}
                                          {rolexModuleData?.find(
                                            (data1) =>
                                              pathname === data1?.description &&
                                              data1?.delete === 1
                                          ) && data?.user_id === user_id ? (
                                            <NavLink
                                              onClick={() =>
                                                deleteTaskComment(
                                                  data?.tasks_user_comment_id
                                                )
                                              }
                                            >
                                              <FaTrash />
                                            </NavLink>
                                          ) : null}
                                        </div>
                                      </div>

                                      <div className="commentdescription mb-3">
                                        <span>{data?.comment}</span>
                                      </div>
                                      <div className="commentdate">
                                        <p className="mb-0">
                                          {new Date(
                                            data?.updatedDate
                                          ).toLocaleString("en-IN", {
                                            timeZone: "Asia/Kolkata",
                                            year: "numeric",
                                            month: "short",
                                            day: "numeric",
                                            hour: "numeric",
                                            minute: "numeric",
                                          })}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                            </>
                          ) : (
                            // </Scrollbars>
                            <div className="default-text">
                              There are no comments!
                            </div>
                          )}
                        </div>
                        {rolexModuleData?.find(
                          (data1) =>
                            pathname === data1?.description && data1?.create === 1
                        ) || roles?.find((data) => data?.role_id === 1001) ? (
                          <div className="postcommentwrap">
                            <div className="imgWrap">
                              <img
                                src={
                                  userProfile?.profileImageUrl?.length > 0
                                    ? global.SERVER_URL +
                                      "/userImg/" +
                                      userProfile?.profileImageUrl
                                    : profileImg
                                }
                                alt="User Profile Images"
                              />
                            </div>
                            <div className="posttext">
                              <input
                                name="comment-text"
                                id="comment-text"
                                placeholder="Write a comment"
                                type="text"
                                className="form-control"
                                value={currentComment}
                                onChange={(e) =>
                                  setCurrentComment(e.target.value)
                                }
                                onKeyPress={(event) => {
                                  event.key === "Enter" && postTaskComment();
                                }}
                              />
                              <NavLink onClick={postTaskComment}>
                                <FaPaperPlane />
                                 {/* <FaPlusCircle onClick={() => {onButtonClick2()}} title="Add Attachment" />
                                <input
                                  accept=".pdf,.xlsx,.doc"
                                  id="task-comment-document"
                                  ref={inputFile2}
                                  onChange={onSelectFileComment}
                                  name="document"
                                  type="file"
                                /> */}
                              </NavLink>
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </Tab>
                    <Tab eventKey="third" title="Documents">
                      <div className="uploadWrap">
                        <Row>
                          {documentList?.length > 0 ? (
                            documentList
                              ?.sort((a, b) =>
                                a.updatedDate < b.updatedDate ? 1 : -1
                              )
                              ?.map((data) => (
                                <Col md={3}>
                                  <div className="uploadDocuments">
                                    <div className="uploadbox-wrap">
                                      <div className="uploaddoc">
                                        <NavLink
                                          className="p-0"
                                          href={
                                            global.SERVER_URL +
                                            "/taskDoc/" +
                                            data?.documents
                                          }
                                          target="_blank"
                                        >
                                          {" "}
                                          {data?.document_type === "xlsx" ? (
                                            <FaFileExcel />
                                          ) : data?.document_type === "pdf" ? (
                                            <FaFilePdf />
                                          ) : (
                                            <FaFileWord />
                                          )}{" "}
                                        </NavLink>
                                      </div>
                                      <div className="fileUserInfo">
                                        <div>
                                          {data?.user_master?.[0]?.name}
                                        </div>
                                        <div>
                                          {new Date(
                                            data?.createdDate
                                          ).toLocaleString("en-IN", {
                                            timeZone: "Asia/Kolkata",
                                            weekday: "short",
                                            year: "numeric",
                                            month: "long",
                                            day: "numeric",
                                            hour: "numeric",
                                            minute: "numeric",
                                          })}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="attachfile">
                                      <small className="filename">
                                        {data?.documents?.split("-")?.slice(2)}
                                      </small>
                                      <div className="actionBtn">
                                        {(rolexModuleData?.find(
                                          (data1) =>
                                            pathname === data1?.description &&
                                            data1?.delete === 1
                                        ) &&
                                          data?.user_id === user_id) ||
                                        roles?.find(
                                          (data) => data?.role_id === 1001
                                        ) ? (
                                          <NavLink
                                            className="deleteicon"
                                            onClick={() =>
                                              deleteTaskDocument(
                                                data?.tasks_documents_id
                                              )
                                            }
                                          >
                                            <FaTrashAlt />
                                          </NavLink>
                                        ) : null}
                                        <NavLink
                                          className="downloadicon"
                                          href={
                                            global.SERVER_URL +
                                            "/taskDoc/" +
                                            data?.documents
                                          }
                                          target="_blank"
                                        >
                                          <FaDownload />
                                        </NavLink>
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              ))
                          ) : (
                            <div className="default-text">
                              {fileName?.length > 0
                                ? "Upload Your File"
                                : "There are no documents!"}
                            </div>
                          )}
                        </Row>
                      </div>

                      {/** Upload Button Code Goes Here **/}
                      {rolexModuleData?.find(
                        (data1) =>
                          pathname === data1?.description && data1?.create === 1
                      ) || roles?.find((data) => data?.role_id === 1001) ? (
                        fileName?.length > 0 ? (
                          <>
                            <div className="d-flex align-items-center mt-3 mb-3">
                              <small className="attachfile d-inline-block">
                                {fileName}
                              </small>
                              <NavLink
                                onClick={FileManage}
                                style={{
                                  padding: "0",
                                  lineHeight: "14px",
                                  marginLeft: "6px",
                                }}
                              >
                                <FaTimes />
                              </NavLink>
                            </div>
                            <Button
                              className="btn cancelbtn btn btn-secondary"
                              onClick={uploadTaskDocument}
                            >
                              Upload File
                            </Button>
                          </>
                        ) : (
                          <div
                            className="file-input"
                            onClick={() => {
                              onButtonClick();
                            }}
                          >
                            <span className="plus-icon">+</span>
                            <label className="button" for="myFile">
                              Browse File
                            </label>
                            <input
                              accept=".pdf,.xlsx,.doc,.docx,.csv"
                              id="task-document"
                              ref={inputFile}
                              onChange={onSelectFile}
                              name="document"
                              type="file"
                            />
                          </div>
                        )
                      ) : null}
                    </Tab>
                    <Tab eventKey="fourth" title="Timeline History">
                      <div className="auditStatus">
                        {auditData?.length > 0 ? (
                          //   <Scrollbars
                          //   autoHeight={true}
                          //   autoHeightMax={350}
                          //   >
                          <>
                            {auditData?.map((data) => (
                              <div className="statusContainer">
                                <div className="dateWrap">
                                  <span>
                                    {new Date(data?.updatedDate).toLocaleString(
                                      "en-IN",
                                      {
                                        timeZone: "Asia/Kolkata",
                                        weekday: "short",
                                        year: "numeric",
                                        month: "long",
                                        day: "numeric",
                                      }
                                    )}
                                  </span>
                                </div>
                                <div className="auditContent">
                                  <p className="auditText">
                                    {data?.user_master?.[0]?.name}{" "}
                                    <span className="highlight-sec">
                                      {data?.notification_type}{" "}
                                    </span>
                                    {data?.description}
                                  </p>
                                  <span className="auditTime">
                                    at{" "}
                                    {new Date(data?.updatedDate).toLocaleString(
                                      "en-IN",
                                      {
                                        timeZone: "Asia/Kolkata",
                                        hour: "numeric",
                                        minute: "numeric",
                                      }
                                    )}
                                  </span>
                                </div>
                              </div>
                            ))}
                          </>
                        ) : (
                          // </Scrollbars>

                          <>There is no audit available yet!</>
                        )}
                      </div>
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </Col>
          </div>
        </div>
      </div>

      <Slidebar
        openSidebar={modal}
        title="Timesheet Information"
        handleClose={handleClose}
        handleSubmit={postTaskTimeSheet}
        content={
          <Form className="modelform">
            <FormGroup>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label htmlFor="timesheetDate">Date*</Label>
                    <Input
                      type="date"
                      id="timesheetDate"
                      name="timesheetDate"
                      value={timesheetUser?.timesheetDate}
                      max={
                        taskData?.taskEndDate > currentDate
                          ? currentDate
                          : taskData?.taskEndDate
                      }
                      min={
                        taskData?.taskStartDate > previousDate
                          ? taskData?.taskStartDate
                          : previousDate
                      }
                      onChange={(e) =>
                        setTimsheetUser({
                          ...timesheetUser,
                          timesheetDate: e.target.value,
                          timesheetDuration: "",
                          timesheetStartTime: "",
                          timesheetEndTime: "",
                        })
                      }
                      disabled={timesheetUser?.updateId}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label htmlFor="user_id">Username</Label>
                    <Input
                      type="text"
                      id="user_id"
                      name="user_id"
                      value={userProfile?.username}
                      disabled
                    />
                  </FormGroup>
                </Col>
                <Col md={6} className="dailyLogInput">
                  <FormGroup>
                    <Label htmlFor="dailyLog">Daily Log (in hours)*</Label>
                    <Input
                      type="number"
                      id="dailyLog"
                      name="dailyLog"
                      max={
                        timesheetTimeDateList?.filter(
                          (data) => data?.label === timesheetUser?.timesheetDate
                        )?.length > 0
                          ? timesheetTimeDateList?.filter(
                              (data) =>
                                data?.label === timesheetUser?.timesheetDate
                            )?.[0]?.totalSum
                          : parseFloat(serialSequence[4]?.hours) +
                            parseFloat(serialSequence[4]?.minutes) / 100
                      }
                      min={"0.1"}
                      value={timesheetUser?.timesheetDuration}
                      onChange={(e) =>
                        setTimsheetUser({
                          ...timesheetUser,
                          timesheetDuration: e.target.value,
                        })
                      }
                      disabled={timesheetTimeStatus === "1" ? true : false}
                      step="0.01"
                    />
                    {/* <Input type="number" id="dailyLog" name="dailyLog" max={'12'} min={"1"} value={timesheetUser?.timesheetDuration} onChange={(e) => setTimsheetUser({ ...timesheetUser, timesheetDuration: e.target.value })} disabled={timesheetTimeStatus === "1" ? true : false} step="0.10" /> */}
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label htmlFor="status">Billing Type</Label>
                    <Select
                      classNamePrefix="react-select"
                      className="single-select"
                      menuPlacement="auto"
                      maxMenuHeight={200}
                      value={timesheetUser?.BillingType}
                      onChange={(select) =>
                        setTimsheetUser({
                          ...timesheetUser,
                          BillingType: select,
                        })
                      }
                      options={billingType}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "rgba(2, 137, 255,.2)",
                          primary50: "rgba(2, 137, 255,.2)",
                          primary75: "rgba(2, 137, 255,.2)",
                          primary: "#0289ff",
                        },
                      })}
                    />{" "}
                  </FormGroup>
                </Col>
                <Col
                  md={6}
                  className={
                    timesheetTimeStatus === "1"
                      ? "chooseTime show"
                      : "chooseTime"
                  }
                >
                  <FormGroup>
                    <Label htmlFor="starttime">Start Time*</Label>

                    <Input
                      type="time"
                      id="starttime"
                      name="starttime"
                      value={timesheetUser?.timesheetStartTime}
                      onChange={(e) =>
                        setTimsheetUser({
                          ...timesheetUser,
                          timesheetStartTime: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
                <Col
                  md={6}
                  className={
                    timesheetTimeStatus === "1"
                      ? "chooseTime show"
                      : "chooseTime"
                  }
                >
                  <FormGroup>
                    <Label htmlFor="endtime">End Time*</Label>
                    <Input
                      type="time"
                      id="endtime"
                      name="endtime"
                      value={timesheetUser?.timesheetEndTime}
                      onChange={(e) =>
                        setTimsheetUser({
                          ...timesheetUser,
                          timesheetEndTime: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
                {timesheetUser?.updateId != null ? null : (
                  <Col md={12}>
                    <NavLink
                      className="timeset"
                      onClick={() => {
                        setTimesheetTimeStatus(
                          timesheetTimeStatus === "1" ? "0" : "1"
                        );
                        setTimsheetUser({
                          ...timesheetUser,
                          timesheetDuration: "",
                          timesheetStartTime: "",
                          timesheetEndTime: "",
                        });
                      }}
                    >
                      {timesheetTimeStatus === "1"
                        ? "Set Daily Log"
                        : "Set Start & End Time"}
                    </NavLink>
                  </Col>
                )}

                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="userNotes">Notes*</Label>
                    <Input
                      type="textarea"
                      id="userNotes"
                      name="userNotes"
                      value={timesheetUser?.timesheetDescription}
                      onChange={(e) =>
                        setTimsheetUser({
                          ...timesheetUser,
                          timesheetDescription: e.target.value,
                        })
                      }
                      style={{ minHeight: "100px" }}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </FormGroup>
          </Form>
        }
      />
    </>
  );
}

export default TaskDetail;
